import React from 'react';
import Trend from 'react-trend'
import {
  Link,
  NavLink,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'

import './AllFans.css';

import { getRandomInt, randomDataArr } from '../helpers'
import fans from '../data/list.small.json';

fans.length = 100;
// console.log(fans);
// console.log(fans[0]);
// const profiles = fans.map(item => item.profile);
// const music = fans.map(item => item.preference.music.value)

class Menu extends React.Component {
  state = {
    showMenu: false,
  }

  toggleMenu = (ev) => {
    this.setState({ showMenu: !this.state.showMenu });
  }

  showMenu = (ev) => {
    this.setState({ showMenu: true });
  }

  closeMenu = (ev) => {
    this.setState({ showMenu: false });
  }
  
  render() {
    const { className } = this.props;
    const menu = this.state.showMenu ? 'menu menu--show' : 'menu';
    const menu__content = className ? `menu__content ${className}` : 'menu__content';
    const MenuButton = this.props.button;

    function activeUrl(url) {
      const location = window.location.pathname.split('/').pop();
      switch (location) {
        case 'fans':
          return 'All Fans'
        case 'music':
          return 'Music festivals fans'
        case 'film':
          return 'Film festivals fans'
        case 'food':
          return 'Food festivals fans'
        case 'sport':
          return 'Sports events fans'
        case 'tech':
          return 'Tech events fans'
        default:
          break;
      }
    }

    return (
      <div className={menu} onBlur={this.closeMenu} tabIndex="0">
        {/* <div className="" onClick={this.toggleMenu}>
          <MenuButton/>
        </div> */}
        <h2 className="fans-menu__button" onClick={this.toggleMenu}>{activeUrl()}</h2>
        <div className={menu__content} onClick={this.closeMenu}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

const Button = () => (
  <h2 className="fans-menu__button">All Fans</h2>
)

const FansMenu = ({ match }) => (
  <Menu button={Button} match={match} className="fans-menu">
    <Link to={`${match.url}`} className="fans-menu__item">All fans</Link>
    <Link to={`${match.url}/music`} className="fans-menu__item">Music festivals fans</Link>
    <Link to={`${match.url}/film`} className="fans-menu__item">Film festivals fans</Link>
    <Link to={`${match.url}/food`} className="fans-menu__item">Food festivals fans</Link>
    <Link to={`${match.url}/sport`} className="fans-menu__item">Sports events fans</Link>
    <Link to={`${match.url}/tech`} className="fans-menu__item">Tech events fans</Link>
  </Menu>
)

const Channels = ({ channel }) => (
  Object.keys(channel).map((item, i) => 
    <div className={`fa fa--mod fa-${item}`} key={i}></div>
  )
)

const FanProfile = ({
  location,
  profile, 
  channel,
  preference,
  togglePreview,
}) => {
  return (
    <div>
      {/* <Trend
        smooth
        autoDraw
        autoDrawDuration={3000}
        autoDrawEasing="ease-out"
        data={randomDataArr(12)}
        gradient={['#00c6ff', '#F0F', '#FF0']}
        radius={10}
        strokeWidth={1}
        strokeLinecap={'butt'}
        padding={2}
      /> */}
      {/* <div>Favourite Artists</div> */}
      <div className="flex">
        <div className="fan-pref">
          <div className="fan-pref__placeholder">Favourite Artists</div>
        </div>
        {
          preference.music.value.map((item, i) => 
            <div className="fan-pref" key={i} >
              <div className="fan-pref__descr">{item.name}</div>
              <img className="fan-pref__img" src={item.img} alt={item.name} />
            </div>
          )
        }
      </div>
      <div className="flex">
        <div className="fan-pref">
          <div className="fan-pref__placeholder">Favourite Songs</div>
        </div>
        {
          preference.song.value.map((item, i) => 
            <div className="fan-pref" key={i}>
              <div className="fan-pref__descr">
                <div>{item.name}</div>
                <div>{item.subtle}</div>
              </div>
              <img className="fan-pref__img" src={item.img} alt={item.name} />
            </div>
          )
        }
      </div>
      <div className="flex">
        <div className="fan-pref">
          <div className="fan-pref__placeholder">Favourite Videos</div>
        </div>
        {
          preference.youtube.value.map((item, i) => 
            <div className="fan-pref" key={i}>
              
              <a href={`https://www.youtube.com/watch?v=${item.yt}`}>
              <div className="fan-pref__descr">{item.name}</div>   <img className="fan-pref__img" src={`https://img.youtube.com/vi/${item.yt}/0.jpg`} alt=""/>
              </a>
            </div>
          )
        }
      </div>
      
      {/* <div className="flex-between">
      {
        Object.keys(channel).map((item, i) => 
          <div className={`fa fa--mod fa-${item}`} key={i}>
            {channel[item].influence}
          </div>
        )
      }
      </div> */}
    </div>
  )
}

const FanPreview = ({
  location,
  profile, 
  channel,
  togglePreview,
}) => {
  const homeCode = location.home.label.code;
  return (
    <div className="fan-preview" onClick={togglePreview}>
      <div className="fan-preview__col">Anonymous</div>
      <div className="fan-preview__col">{profile.sex}</div>
      <div className="fan-preview__col">{profile.age}</div>
      <div className="fan-preview__col">{profile.influence}</div>
      <div className="fan-preview__col">{profile.married && 'married'}</div>
      <div className="fan-preview__col">{homeCode}</div>
      <div className="fan-preview__col">{location.home.label.region.main}</div>
      <div className="fan-preview__col">{location.home.label.region.sub}</div>
      <div className="fan-preview__col">
        <Channels channel={channel}/>
        {/* <div className="fa fa--mod fa-facebook"></div>
        <div className="fa fa--mod fa-instagram"></div>
        <div className="fa fa--mod fa-twitter"></div>
        <div className="fa fa--mod fa-google"></div>
        <div className="fa fa--mod fa-youtube"></div>
        <div className="fa fa--mod fa-snapchat"></div>
        <div className="fa fa--mod fa-spotify"></div> */}
      </div>
      <div className="fan-preview__col w16">
        { profile.sex !== 'unknown' && <div className="fa fa-star"></div> } 
      </div>
      {/* <div className="fan-preview__button">Show profile</div> */}
    </div>
  )
}

class FanItem extends React.Component {
  state = {
    expand: false,
  }

  // componentDidUpdate(prevProps, prevState) {
    
  // }

  // shouldComponentUpdate(nextProps, nextState) {
  //   // if (this.state.expand === nextState.expand) return true;
  // }

  togglePreview = () => {
    this.setState({ expand: !this.state.expand });
  }

  render() {
    const {
      location,
      profile,
      channel,
      preference,
    } = this.props;

    return (
      <div>
        <FanPreview 
          location={location} 
          profile={profile} 
          channel={channel} 
          togglePreview={this.togglePreview}
        />
        { this.state.expand && 
          <FanProfile 
            location={location} 
            profile={profile} 
            channel={channel} 
            preference={preference}
            togglePreview={this.togglePreview}
          />
        }
      </div>
    )
  }
}

const FanList = ({
  collection,
  items,
}) => {
  return (
    <div className="fan-list">
      <div className="fan-preview fan-preview--legend">
        <div className="fan-preview__col">NAME</div>
        <div className="fan-preview__col">SEX</div>
        <div className="fan-preview__col">AGE</div>
        <div className="fan-preview__col">INFLUENCE</div>
        <div className="fan-preview__col">STATUS</div>
        <div className="fan-preview__col">COUNTRY</div>
        <div className="fan-preview__col">MAIN REGION</div>
        <div className="fan-preview__col">SUB REGION</div>
        <div className="fan-preview__col">CHANNELS</div>
        <div className="fan-preview__col w16">SUPER</div>
        {/* <div className="fan-preview__button">Show Profile</div> */}
      </div>
      {
        collection.slice(...items).map((props, i) => 
          <FanItem {...props} key={i} />
        )
      }
      <div className="fan-preview fan-preview--button">Show More</div>
    </div>
  )
}

const AllFans = ({
  match,
}) => {
  function getNumbers() {
    const location = window.location.pathname.split('/').pop();
    switch (location) {
      case 'fans':
        return 14701147;
      case 'music':
        return 7435239
      case 'film':
        return 4520979
      case 'food':
        return 3352326
      case 'sport':
        return 5588539
      case 'tech':
        return 3554391
      default:
        break;
    }
  }
  return (
    <div>
      <div className="flex-between">
        <div className="fg1">
          <FansMenu match={match}/>
        </div>
        {/* <h2>All Fans</h2> */}
        <div className="fg2 tac fans-total">Total {getNumbers().toLocaleString()}</div>
        <div className="flex fg1 jcfe">
          <div className="button button--small">Upload .csv</div>
          <div className="button button--small">Download .csv</div>
        </div>
        {/* <p>When you upload your own data set, allow us to apply quick data crunching and come back in 1-2 business days to let you know when your data is cleaned, formatted and uploaded to your new segment</p> */}
      </div>
      {/* <FanProfile /> */}
      <Switch>
        <Route exact path={`${match.url}`} render={(props) => 
          <FanList collection={fans} items={[0,10]} />}/>
        <Route path={`${match.url}/all`} render={(props) => 
          <FanList collection={fans} items={[10,20]} />}/>
        <Route path={`${match.url}/music`} render={(props) => 
          <FanList collection={fans} items={[20,30]} />}/>
        <Route path={`${match.url}/film`} render={(props) => 
          <FanList collection={fans} items={[30,40]} />}/>
        <Route path={`${match.url}/food`} render={(props) => 
          <FanList collection={fans} items={[40,50]} />}/>
        <Route path={`${match.url}/sport`} render={(props) => 
          <FanList collection={fans} items={[50,60]} />}/>
        <Route path={`${match.url}/tech`} render={(props) => 
          <FanList collection={fans} items={[60,70]} />}/>
        <Redirect to={`${match.url}`}/>
      </Switch>
    </div>
  )
}

export default AllFans


// WEBPACK FOOTER //
// ./src/components/AllFans.js